export default __webpack_public_path__ + "static/media/route.d2406e9b.png";